module.exports = __webpack_public_path__ + "img/浦发银行.811923e4.png";